module.exports = __webpack_public_path__ + "img/equipment_active.236f01d4.svg";